/**
 * @flow
 * @relayHash d58f65d415feac7e7c2d7781c57cb788
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type OnPageCategory_project$ref = any;
export type onpage_OnPageCategory_QueryVariables = {|
  host: string
|};
export type onpage_OnPageCategory_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: OnPageCategory_project$ref
  |}
|};
export type onpage_OnPageCategory_Query = {|
  variables: onpage_OnPageCategory_QueryVariables,
  response: onpage_OnPageCategory_QueryResponse,
|};
*/


/*
query onpage_OnPageCategory_Query(
  $host: String!
) {
  project(host: $host) {
    ...OnPageCategory_project
    id
  }
}

fragment OnPageCategory_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      cursor
      node {
        countTitleIssues
        countDescriptionIssues
        countH1Issues
        countContentIssues
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "onpage_OnPageCategory_Query",
  "id": null,
  "text": "query onpage_OnPageCategory_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...OnPageCategory_project\n    id\n  }\n}\n\nfragment OnPageCategory_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      cursor\n      node {\n        countTitleIssues\n        countDescriptionIssues\n        countH1Issues\n        countContentIssues\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "onpage_OnPageCategory_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "OnPageCategory_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "onpage_OnPageCategory_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countTitleIssues",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countDescriptionIssues",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countH1Issues",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countContentIssues",
                        "args": null,
                        "storageKey": null
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0632272cfbd2439473327c3632fc592a';
module.exports = node;
